export default __webpack_public_path__ + "assets/images/ladder-15d2858a2ced6856655ff905178fd562.svg";